import MapComponent from 'components/map/MapComponent'

import { useRef, useState } from 'react'

import Breadcrumb from 'components/Breadcrumb/Breadcrumb'
import { useGetZone } from './hooks/useGetZone'
import MapActions from './map-actions'
import MapAddAction from './map-add-actions'
import MapArea from './map-area'
import SidebarContent from './sidebar/sidebar-content'
import HelpColor from 'pages/map/hubZoneOperation/HelpColor'

const DetermainGeo = () => {
  const refMap = useRef({})

  const { polygons, setSelectedPolygons, getZoneInfo, response } = useGetZone()
  const [selectedHub, setSelectedHub] = useState<any>({})

  return (
    <div className='w-full h-full !p-[0px]'>
      <Breadcrumb curentPage='تعیین مناطق توزیع / جمع آوری' />

      <div className='flex w-full h-full gap-5'>
        <div className='w-[350px] h-full flex flex-col items-start gap-5'>
          <SidebarContent
            setSelectedPolygons={setSelectedPolygons}
            polygons={polygons}
            getZoneInfo={getZoneInfo}
            response={response}
            selectedHub={selectedHub}
            setSelectedHub={setSelectedHub}
          />
        </div>
          <div className='w-[80%] h-full relative DeterminingAreas'>
          <HelpColor />
            <MapComponent zoom={11} ref={refMap}>
              <MapActions
                polygonData={polygons}
                setSelectedPolygons={setSelectedPolygons}
                getZoneInfo={getZoneInfo}
                selectedHub={selectedHub}
              />
              <MapAddAction
                getZoneInfo={getZoneInfo}
                setSelectedPolygons={setSelectedPolygons}
                polygonData={polygons}
              />
              <MapArea area={polygons} />
            </MapComponent>
          </div>
        </div>
    
    </div>
  )
}

export default DetermainGeo
